// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"e1c551aed425a97f0ec3","532":"cc49457fd757cd1b7d49","678":"59c57588d950b4a50493","883":"31123f3e7c7e463fe68e"}[chunkId] + ".js";
};